import { render, staticRenderFns } from "./CIDApp.vue?vue&type=template&id=4accde0e&"
import script from "./CIDApp.vue?vue&type=script&lang=js&"
export * from "./CIDApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports